import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { Loader, NewsCard, Pagination } from 'ui';
import { formatDate } from 'shared/functions';
import { artifactTypesLabels } from 'shared/constants/artifactTypes';

const useStyles = makeStyles(() => ({
  noData: {
    padding: 8,
    marginBottom: 18,
  },
  alignText: {
    textAlign: 'center',
  },
}));

const ArtifactsNews = ({
  isPending,
  data,
  total,
  currentPage,
  limit,
  onItemClick,
  onChangePage,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const pagesTotal =
    Number.isInteger(total) && Number.isInteger(limit) ? Math.ceil(total / limit) : undefined;

  return (
    <>
      {data.length > 0 &&
        data.map(
          ({
            id,
            shortTitle,
            shortText,
            artifactType,
            publicationDate,
            imageFilename,
            restricted,
            source,
          }) => (
            <Box mb={3} key={id}>
              <NewsCard
                onClick={() => onItemClick(id)}
                title={shortTitle}
                teaser={shortText}
                footer={`${artifactTypesLabels[artifactType]} - ${formatDate(publicationDate)}`}
                imgUrl={imageFilename}
                restricted={restricted}
                source={source}
              />
            </Box>
          ),
        )}
      {!isPending && data.length === 0 && (
        <Paper className={classes.noData}>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={classes.alignText}
          >
            {t('There are no news feed data.')}
          </Typography>
        </Paper>
      )}
      {pagesTotal > 0 && (
        <Pagination
          onChange={onChangePage}
          page={currentPage}
          count={pagesTotal}
          rowsPerPage={limit}
          background
        />
      )}
      {isPending && <Loader center={data.length === 0} cover={data.length > 0} />}
    </>
  );
};

ArtifactsNews.defaultProps = {
  isPending: false,
  total: null,
  limit: null,
  onChangePage: () => null,
  onItemClick: () => null,
};

ArtifactsNews.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      teaser: PropTypes.string,
      footer: PropTypes.string,
      imgUrl: PropTypes.string,
    }),
  ).isRequired,
  currentPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func,
  onItemClick: PropTypes.func,
  isPending: PropTypes.bool,
  total: PropTypes.number,
  limit: PropTypes.number,
};

export default ArtifactsNews;
